import { render, staticRenderFns } from "./menuConversion.vue?vue&type=template&id=64807df7"
import script from "./menuConversion.vue?vue&type=script&lang=js"
export * from "./menuConversion.vue?vue&type=script&lang=js"
import style0 from "./menuConversion.vue?vue&type=style&index=0&id=64807df7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports